export default __webpack_public_path__ + "assets/b1b4b86c1fa40790a98152447328a9ba.png";